import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2bbf128a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\ecng-frontend\\EasyCard\\UI\\merchant\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbf128a')) {
      api.createRecord('2bbf128a', component.options)
    } else {
      api.reload('2bbf128a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2bbf128a", function () {
      api.rerender('2bbf128a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/main/Index.vue"
export default component.exports